import {qspost} from "@/config/axios";

export const list = data => qspost("request?", data, "shortVideoReport");
